import React, { Component } from "react";
import { Container } from "reactstrap";

class PrivacyPolicy extends Component {
  render() {
    return (
      <div>
       <Container className="pt-lg-5 mt-lg-5">
          <h1>Terms of Service(TOS)</h1>
        </Container>
        <Container style={{ marginTop: "2rem", marginBottom: "2rem", color: 'white'}}>
          <b>I. Introduction and Eligibility</b>
          <br />
          <br />
          <p>
            {" "}
            These Terms of Use (“Terms”) constitute a binding agreement between
            you and Lighthouse Digital LLC.a Georgia limited liability company
            (the "Company"), and its affiliates and subsidiaries (“Lighthouse
            Digital,” “we,” “us”). Please read these Terms carefully before
            using the Lighthouse Digital Service (defined below). “You” and
            “users” shall mean all visitors to the Lighthouse Digital Service.
            These Terms include Lighthouse Digital’s Privacy and Cookies Policy
            (“Privacy Policy”), which is incorporated by reference into these
            Terms. We have included several annotations in boxes to help explain
            the legal jargon and emphasize key sections. These annotations are
            for convenience only and have no legal or contractual effect. Your
            use of the Lighthouse Digital Service signifies your agreement to be
            bound by these Terms each time you access the Lighthouse Digital
            Service. If you do not agree to any of these Terms, do not use the
            Lighthouse Digital Service. If you are under 18 years of age, you
            represent and agree that you possess the legal consent of your
            parent or guardian to access and use the Lighthouse Digital Service.
            <br />
            <br />
            This agreement is a legally binding contract. It may change as our
            service changes, and you agree you will review it and any updates
            regularly.
            <br />
            <br />
            <b> Revisions to Terms.</b>We reserve the right, in our sole
            discretion, to revise these Terms at any time, in whole or in part,
            by posting an updated version. Changes to these Terms will be
            effective when posted. You agree to visit this page periodically to
            review the most current Terms and your continued use of the
            Lighthouse Digital Service, or any part thereof after any changes to
            these Terms are posted constitutes your binding acceptance of these
            Terms. If you object to any changes to these Terms, your sole
            recourse will be to stop using the Lighthouse Digital Service.
            <br />
            <br />
            <b>Children.</b> No part of the Lighthouse Digital Service is
            directed to persons under the age of 13. The terms “post” and
            “posting” as used in these Terms shall mean the act of submitting,
            uploading, publishing, displaying, or similar action on the
            Lighthouse Digital Service.
            <br />
            <br />
            If you are not a resident of the United States, by using the
            Lighthouse Digital Service and submitting personal information to
            us, you consent to the transfer of your information to the United
            States.
            <br />
            <br />
            <b> International Users.</b> The Lighthouse Digital Service is
            operated from the United States, but may be accessed in other parts
            of the world. If you are located outside of the United States and
            you access or use the Lighthouse Digital Service, you acknowledge,
            understand and agree that you are doing so on your own initiative
            and at your own risk and that it is your responsibility (and not
            ours) to make sure that your use of the Lighthouse Digital Service
            complies with all applicable local laws in the jurisdiction from
            where you access or use the Lighthouse Digital Service. By
            submitting any personally identifiable information to us through the
            Lighthouse Digital Service, you consent to the transfer, processing
            and storage of your information in the United States in accordance
            with our Privacy Policy .
            <br />
            <br />
            <b>II. The Lighthouse Digital Service</b>
            <br />
            <br />
            The <b>“Lighthouse Digital Service”</b> means the website located at
            www.ATLighthouse.com or ATLighthouse.com and any associated
            software, applications, and Internet services under Lighthouse
            Digital’s control, whether partial or otherwise, used in connection
            with providing the services provided by Lighthouse Digital. The
            Lighthouse Digital Service provides an online platform to enable you
            to view information online and through other connected devices about
            courses, workshops, classes and other education and corporate
            training programs and events offered by Lighthouse Digital
            (collectively,<b>“Courses”</b> ). These Courses are at the
            intersection of technology, strategy, design and data and may be
            made available for free or for a fee, in Lighthouse Digital’s sole
            discretion. Together with our members, thought leaders, and seasoned
            practitioners (collectively <b>“Instructors”</b> ), Lighthouse
            Digital offers a robust curriculum focused on entrepreneurship and
            practices by which design and technology can be leveraged to create
            industry-changing products and successful companies. The Lighthouse
            Digital Service will also permit the community of users of the
            Lighthouse Digital Service to engage in discussions and
            communications with one another and with the Instructors.{" "}
            <b> “Premium Content”</b> means Lighthouse Digital’s multi-media
            content library of all prior and current Courses and live-stream
            transmissions of future Courses.
            <br />
            <br />
            <b> Sign Up for a Course.</b> You may sign up for a Course using the
            <span> <a  href='documents/Lighthouse-Digital-LLC-Catalog-(2019-2020)-2.0.pdf'
                 target='_blank'> Lighthouse Digital Service.</a></span>   We cannot promise the availability of
            the Course.
            <br />
            <br />
            <b> Cancellation and No Show Policies. </b> We determine the
            rescheduling and cancellation policies and apply them at our sole
            discretion. You should contact your assigned program administrator
            directly, not Instructors, for any rescheduling or cancellation
            questions. The Lighthouse Digital Cancellation Policy is available
            here and is incorporated into these Terms.
            <br />
            <br />
            <b>Chat Room Service and Blog Post.</b> You may be able to engage in
            online chat sessions with other users of the Lighthouse Digital
            Service, including Instructors, as well as post comments on blog
            posts. You should exercise caution, good sense, and sound judgment
            when submitting messages or information to be posted in a chat room
            or on a blog. Think – and read twice – before you post anything.
            Once something is posted online it may live in perpetuity, and
            messages posted today could be highly embarrassing or damaging to
            your credibility or reputation in the future. You are responsible
            for any comments or materials you post in a chat room or on a blog,
            and you assume all liability arising out of a post. We discourage
            the posting of sensitive or personal information in comments or
            posts and we are not responsible for the use of your personal
            information that you publicly post by any third parties. Lighthouse
            Digital makes no representations and warranties with respect to the
            confidentiality of any posts you make through the Lighthouse Digital
            Service.
            <br />
            <br />
            <b> Information You Provide to Instructors. </b> Your Instructors
            may ask you for information, including personal information, such as
            your email address or messaging application information, to help
            facilitate the provision of the Course. Instructors are required to
            use this information only to communicate about Course materials in a
            professional manner. However, you agree that we are not responsible
            for any use of this information by an Instructor for other purposes.
            <br />
            <br />
            <b>Third-Party Services.</b> The Lighthouse Digital Service may link
            to third-party websites to facilitate its provision of services to
            you. If you use these links, you will leave the Lighthouse Digital
            Service. Some of these third-party websites may use Lighthouse
            Digital Content (defined below) under license from Lighthouse
            Digital. Lighthouse Digital is not responsible for these third-party
            websites, whether or not Lighthouse Digital is affiliated with such
            third-party websites. Through our use, we do not endorse the
            organizations sponsoring such third-party websites or their products
            or services. You agree that Lighthouse Digital is not responsible or
            liable for any loss or damage of any sort incurred as a result of
            any such dealings you may have on or through a third-party website
            or as a result of the presence of any third-party advertising on the
            Lighthouse Digital Service.
            <br />
            <br />
            <b>
              Lighthouse Digital Is Not Your Attorney or Financial Advisor.
            </b>{" "}
            Do not contact Lighthouse Digital for legal or financial advice. You
            agree and acknowledge that Lighthouse Digital, and its Instructors,
            are not a law firm and are not authorized to practice law in any
            jurisdiction. Lighthouse Digital does not give legal advice in any
            form or practice law in any way. The information obtained from or
            through the Lighthouse Digital Service is for information purposes
            only, and you are solely responsible for confirming the accuracy and
            appropriateness of such information for your own business or venture
            with your own tax, financial, and legal advisors. Lighthouse
            Digital, and its Instructors, are not establishing an
            attorney-client relationship with you through your use or access of
            the Lighthouse Digital Service.
            <br />
            <br />
            <b> Social Sign-On.</b> The Lighthouse Digital Service may allow you
            to register and log in using sign-on functionality provided by
            social networks, such as Facebook. You agree to abide by the social
            networks’ terms and conditions applicable to you.
            <br />
            <br />
            <b>Featuring a Course or Instructor.</b> The Lighthouse Digital
            Service may feature a Course or Instructor as an advertisement, but
            this is not a recommendation of such Course or Instructor. We may
            also recommend a Course as part of a collection of Courses. However,
            as stated more fully elsewhere in these Terms, Lighthouse Digital
            makes no representations as to the quality or nature of Courses or
            Instructors shown on the Lighthouse Digital Service.
            <br />
            <br />
            <b>Featuring Your Student Work.</b> We may promote Lighthouse
            Digital using the work you completed as part of completing a Course
            (“Student Work”) with your permission, and you grant Lighthouse
            Digital a nonexclusive license to use your name in combination with
            your Student Work in any and all media in connection with Lighthouse
            Digital’s promotional efforts. Our use will be limited to promoting
            Lighthouse Digital. Lighthouse Digital will include your name and
            attribute the Student Work to you.
            <br />
            <br />
            <b>III. Financial Matters</b>
            <br />
            <br />
            You may have to pay a fee to attend a Course or subscribe to Premium
            Content through the Lighthouse Digital Service.
            <br />
            <br />
            <b>Courses.</b> Lighthouse Digital may charge you fees to attend a
            Course. The amount of any fees may be revised by Lighthouse Digital
            from time to time and vary from region to region, and topic to
            topic.
            <br />
            <br />
            <b>Premium Content.</b> Lighthouse Digital charges a monthly fee for
            a subscription to Premium Content. Premium Content may be available
            on a free trial or introductory offer basis. If such an offer is
            provided, only one per household or email address is allowed at any
            given point in time. In addition, there is a limit of one trial per
            person and per email address in any given six-month period unless
            otherwise stated in the offer. If you do not cancel your
            subscription within the trial or introductory offer period, we will
            charge the credit card you provided during the sign-up process. You
            will not receive a notice from us that your free trial period has
            ended or that the paying portion of your membership has begun. You
            agree to pay the applicable subscription fee as set forth on this
            site. Lighthouse Digital reserves the right to increase the Premium
            Content subscription fee or institute new charges upon reasonable
            notice. Fees for a Premium Content subscription are due in advance.
            You agree that your membership fee or subscription will be billed
            automatically each month, at or around the day of the month
            corresponding to the day of the month you originally registered for
            Premium Content at the then-current rate to the credit card you used
            in your most recent transaction with us.
            <br />
            <br />
            <b> Cancellation of Premium Content.</b> You may cancel your
            membership at any time and such cancellation will be effective at
            the end of the month in which you provide notice of cancellation. To
            cancel your membership please log in to your account on the website
            and follow the instructions for cancellation. Your membership will
            automatically renew each month, until you notify us of your decision
            to cancel your membership. Lighthouse Digital reserves the right to
            cancel your subscription at any time.
            <br />
            <br />
            <b> You Agree To Pay Us For Your Purchases.</b> You agree to pay for
            all products and services that you purchase through the Lighthouse
            Digital Service, and you agree that we may charge your selected
            payment method, either directly or through the services of a
            third-party payment processor, for any such payments. Only those
            payment methods accepted by our third-party payment processor can be
            used to purchase products, goods, or services through the Lighthouse
            Digital Service.
            <br />
            <br />
            <b>Third-Party Payment Processors.</b> Lighthouse Digital currently
            uses secure third-party payment processors for electronic commerce.
            Our third-party payment processors accept payments through methods
            detailed on the applicable payment screen, which may include various
            credit cards and PayPal. Information that you supply to our payment
            processors is not stored by us or within our control, and is subject
            to each of our third-party payment processors’ own privacy policies
            and terms and conditions. Third-party payment processors may charge
            a fee to process payments and Lighthouse Digital is not responsible
            for any fees charged by them. Lighthouse Digital disclaims all
            liability with regard to any fees or problems you have with
            third-party payment processors
            <br />
            <b></b>
            <br />
            <b>Availability of Certain Forms of Payment.</b> Lighthouse Digital
            makes no representations and warranties about the continued
            availability of any particular form of payment method made available
            for use with the Lighthouse Digital Service.
            <br />
            <br />
            <b>Pre-Authorization.</b> When you provide a credit card number to
            us to activate and/or pay for any fees related to Lighthouse
            Digital, we, through our third-party payment processor, may seek
            pre-authorization of your credit card account prior to a purchase to
            verify the credit card is valid and/or has the necessary funds or
            credit available to cover your purchase. These pre-authorizations
            will reduce your available balance by the authorization amount until
            it is released or reconciled with the actual charge. Please contact
            your card issuer if you have additional questions regarding when an
            authorization amount will be removed from your statement.
            <br />
            <br />
            <b>Timing of Charges.</b> Charges occur within a reasonable time of
            the transaction or shortly thereafter, and multiple charges during
            the same period may be aggregated together.
            <br />
            <br />
            <b>Recurring Payment Program. </b>Lighthouse Digital offers a
            recurring payment program, which allows you to pay the balance owed
            for courses in installments. You can elect to enroll in this program
            by completing and submitting the Recurring Payment Authorization
            Form. If you have submitted this Form you have authorized us to
            charge your checking/savings account or credit card for the amount
            and at the intervals set forth in the Form. You can cancel your
            enrollment in our recurring payment program by notifying us in
            writing at least 15 days prior to the next billing date of your
            intent to cancel the authorization. To cancel, please notify us in
            writing at <b>admin@itslighthouse.com</b>. You are responsible for
            all recurring charges made prior to the effective date of
            cancellation.
            <br />
            <br />
            You may send us an email to dispute charges to your account within
            30 days of the charge
            <br />
            <br />
            <b>Disputed Charges. </b>You agree to submit any disputes regarding
            any charge to your account in writing to Lighthouse Digital within
            thirty (30) days of such charge, or your dispute is waived and such
            charge will be final and not subject to challenge. You may dispute a
            charge by sending an email to us at admin@itslighthouse.com.
            <br />
            <br />
            Lighthouse Digital may provide refunds at its discretion. Our refund
            policy is available here catalogue page.
            {/* CATALOGUE PAGE NEEDED */}
            <br />
            <br />
            <b>Refunds. </b> We reserve the right, but are not obligated, to
            refund fees paid to us. Our policy for providing refunds, if ever,
            for any purchases made by you, is set forth in the Lighthouse
            Digital Refund Policy available in the institutional catalogue and
            is incorporated into these Terms. A cancellation of a Premium
            Content subscription will be effective at the end of the month in
            which we receive notice of cancellation; there will be no pro-rata
            refunds. Lighthouse Digital may modify its refund policy at any time
            with or without specific notice to you; provided, however, that the
            refund policy in effect at the time of any transaction shall apply
            to such purchase despite any subsequent change in such policy.
            Please contact admin@itsghthouse.com to request a refund.
            <br />
            <br />
            <b>Taxes. </b> “Taxes” include sales, use, value added, or
            transaction taxes and other government-imposed fees and charges. You
            are responsible for determining and paying the appropriate taxes
            resulting from a transaction occurring through the Lighthouse
            Digital Service. Lighthouse Digital is not responsible for
            collecting, reporting, paying, or remitting to you any such taxes,
            unless required by law.
            <br />
            <br />
            <b>Currency.</b> We accept payments only in U.S. Dollars and all
            other currencies need to be converted into U.S. Dollar payments.
            Your transaction may be subject to applicable currency
            conversion-related transaction fees and exchange rate changes.
            <br />
            <br />
            <b>IV. Account Creation and Use by an Agent</b>
            <br />
            <br />
            You agree that if you create an account and use the Lighthouse
            Digital Service on behalf of a business entity (e.g., corporation),
            you have the necessary legal authority and capacity to do so as an
            authorized agent of the business entity. You agree that you have the
            authority to bind the business entity in legal agreements and
            contracts.
            <br />
            <br />
            <b> V. Your Account</b>
            <br />
            <br />
            If you create an account, you are responsible for the
            confidentiality of your log-in credentials and for keeping your
            information accurate.
            <br />
            <br />
            You are responsible for any activity resulting from the use of your
            log-in credentials on the Lighthouse Digital Service.
            <br />
            <br />
            To use some parts of the Lighthouse Digital Service, including
            Premium Content, you must create an account. If you subscribe to
            Premium Content, you will need to provide us with your name, email
            address and billing address, as well as your debit/credit card
            information. You represent and warrant that the information you
            provide to Lighthouse Digital upon registration and at all other
            times will be true, accurate, current, and complete. You also
            represent and warrant that you will ensure that this information is
            kept accurate and up-to-date at all times.
            <br />
            <br />
            <b> Your Log-In Credentials. </b>
            You are responsible for maintaining the confidentiality of your
            log-in credentials to you assigned email and online logins and are
            fully responsible for all activities that occur through the use of
            your credentials. You agree to notify us immediately if you believe
            the confidentiality of your log-in credentials has been compromised
            or if you suspect unauthorized use of your account. You agree that
            we will not be liable for any loss or damage arising from
            unauthorized use of your credentials.
            <br />
            <br />
            <b>VI. Communications</b>
            <br />
            <br />
            Lighthouse Digital may communicate with you by email under certain
            circumstances, or by posting a notice on the Lighthouse Digital
            Service/website. You may request that we provide notice of security
            breaches in writing.
            <br />
            <br />
            If you have registered to use the Lighthouse Digital Service or are
            registered for a Course, you agree to receive email from us at the
            email address you provided to us for customer service related
            purposes, even if you have chosen to opt-out of marketing
            communications.
            <b>Electronic Notices.</b> By using the Lighthouse Digital Service
            or providing any personal information to us, you agree that we may
            communicate with you electronically regarding security, privacy, and
            administrative issues relating to your use of the Lighthouse Digital
            Service. If we learn of a security breach relating to your personal
            information that is required to be reported pursuant to applicable
            security breach notification laws, we may attempt to notify you
            electronically by posting a notice on the Lighthouse Digital Service
            or by sending an email to you. You may have a legal right to receive
            this notice in writing. To receive free written notice of a security
            breach (or to withdraw your consent from receiving electronic
            notice), please write to us at admin@ATLighthouse.com.
            <br />
            <br />
            <b>VII. Lighthouse Digital's Content Ownership and Use</b>
            <br />
            <br />
            Lighthouse Digital owns all of the content we create, but you may
            use it, subject to these Terms, while you use the Lighthouse Digital
            Service.
            <b>
              You cannot use our logo, marketing material and trdemarks without
              our written permission.
            </b>
            <br />
            <br />
            The contents of the Lighthouse Digital Service include: designs,
            text, graphics, images, video, information, logos, button icons,
            software, audio files, computer code, and other Lighthouse Digital
            content (collectively, “Lighthouse Digital Content” ). All
            Lighthouse Digital Content and the compilation (meaning the
            collection, arrangement, and assembly) of all Lighthouse Digital
            Content are the property of Lighthouse Digital or its licensors and
            are protected under copyright, trademark, and other laws.
            <br />
            <br />
            <b> License to You.</b>
            Subject to these Terms, we hereby grant you the limited, revocable,
            non-exclusive, non-transferable, non-assignable, worldwide license
            to access and use the Lighthouse Digital Service and the Lighthouse
            Digital Content solely for the use of Lighthouse Digital’s services,
            at our discretion. Any other use is expressly prohibited. This
            license is revocable at any time without notice and with or without
            cause. Unauthorized use of the Lighthouse Digital Content may
            violate copyright, trademark, and applicable communications
            regulations and statutes and is strictly prohibited. You must
            preserve all copyright, trademarks, service marks, and other
            proprietary notices contained in the original Lighthouse Digital
            Content on any copy you make of the Lighthouse Digital Content in
            accordance with these Terms.
            <br />
            <br />
            No Lighthouse Digital Content or other material made available on or
            through the Lighthouse Digital Service may be copied, modified,
            reproduced, duplicated, republished, uploaded, posted, transmitted,
            sold, transferred, publicly displayed, distributed, or used to
            create derivative works, in any way without written permission of
            the copyright owner unless such content is specifically made
            available for and authorized to be downloaded from the Lighthouse
            Digital Service, in which case you are authorized to download a
            single copy of such materials for your own use. For example, certain
            Course materials may be made available as unprotected PDF files that
            can be downloaded by registered Course participants and/or other
            users of the Lighthouse Digital Service. Materials not made
            available for download may not be downloaded or copied without prior
            written permission. Modification of materials obtained from the
            Lighthouse Digital Service, including, but not limited to, User
            Content, for any other purpose, including, without limitation, any
            commercial purpose, is a violation of the copyrights and other
            proprietary rights of Lighthouse Digital or its licensors, unless
            you have obtained express written authorization to the contrary.
            <br />
            <br />
            <b>No Commercial Use.</b> No materials obtained from the Lighthouse
            Digital Service, even if authorized for download from the Lighthouse
            Digital Service, may be redistributed, nor may they be used for any
            commercial purpose, without Lighthouse Digital’s prior written
            permission. Notwithstanding the prior sentence, the use of Course
            materials by a registered student of a Course for the development of
            a business, venture, or idea of which the registered student is
            actively involved as a founder or employee shall not be deemed a
            commercial purpose, but no additional reproductions may be made of
            any such materials, either electronically or in hard copy.
            <br />
            <br />
            <b>
              Additional Licenses. Certain materials made available for download
              from or through the Lighthouse Digital Service may be subject to
              additional or different license terms and conditions, such as
              terms and conditions set forth in a Creative Commons license. Any
              such terms and conditions shall be identified in advance for such
              materials, and by downloading any materials governed by any other
              license terms and conditions, you hereby agree to be bound by and
              comply with such terms and conditions.{" "}
            </b>
            <br />
            <br />
            <b>No Implied Rights. </b>There are no implied licenses granted in
            these Terms.
            <br />
            <br />
            <b>Lighthouse Digital Marks. </b>Lighthouse Digital, the Lighthouse
            Digital logo, “Stay Relevant, ForeverTM “ mark and other Lighthouse
            Digital logos and product and service names are or may be trademarks
            of Lighthouse Digital (the “Lighthouse Digital Marks”). Without our
            prior written permission, and except as solely enabled by any link
            as provided by us, you agree not to display or use in any manner the
            Lighthouse Digital Marks.
            <br />
            <br />
            <b>VIII. Your User Content and Our License to Use</b>
            <br />
            <br />
            You, or the people who allow you to use their content, own all of
            the content you post using the Lighthouse Digital Service. However,
            by posting content to the Lighthouse Digital Service, you are
            granting us a license to use your content for any purpose, including
            in our marketing materials. We may also modify your content, in our
            sole discretion, and without prior approval from you, in order to
            make it work better with the Lighthouse Digital Service.
            <br />
            <br />
            It is very important that you have permission to use other people’s
            content or they may be able to sue you for violating their legal
            rights.
            <br />
            <br />
            <b>Your User Content. </b>The Lighthouse Digital Service may provide
            you with the ability to create, post, or share content, including
            messages in chat rooms or comments on blog posts, as well as Student
            Work (“Your User Content”). You or a third-party licensor, as
            appropriate, retain all intellectual property rights to Your User
            Content. You are responsible for protecting those rights.
            <br />
            <br />
            <b>Lighthouse Digital’s Use of Your User Content. </b>By creating,
            posting, or sharing Your User Content, on or through the Lighthouse
            Digital Service, and subject to Lighthouse Digital’s Privacy Policy,
            and except as otherwise expressly stated, you grant Lighthouse
            Digital an irrevocable, perpetual, transferrable, unconditional,
            unrestricted, sublicenseable, world-wide, non-exclusive,
            royalty-free license to copy, use, reproduce, modify, remove,
            publish, upload, distribute, transmit, publicly display and create
            derivative works from Your User Content for any purpose without
            compensation to you, including for the purpose of promoting
            Lighthouse Digital and our services. Notwithstanding the foregoing,
            with respect to our use of your Student Work, we agree not to modify
            Student Work without your express permission. You waive any rights
            you may have regarding Your User Content, except for Student Work,
            being altered or manipulated in any way that may be objectionable to
            you. We reserve the right to refuse to accept, post, display, or
            transmit any of Your User Content in our sole discretion. Upon your
            request, Lighthouse Digital will discontinue this licensed use
            within a commercially reasonable period after Your User Content is
            removed from the Lighthouse Digital Service.
            <br />
            <br />
            If you are an Instructor, the license grant above is also applicable
            to any content you create for the purpose of your Course (such as
            syllabi, slides or homework) that you post on the Lighthouse Digital
            Course area of the Schoology platform.
            <br />
            <br />
            <b>You Acquire No Ownership of Others’ Content. </b> You understand
            and agree that you will not obtain, through use of the Lighthouse
            Digital Service, any right, title, or interest (including
            intellectual property rights) in content delivered via the
            Lighthouse Digital Service.
            <br />
            <br />
            <b>You Must Have Rights to the Content You Post.</b> You represent
            and warrant that: (i) you own the content posted by you on or
            through the Lighthouse Digital Service or otherwise have the right
            to grant the license set forth in these Terms; (ii) the posting and
            use of Your User Content on or through the Lighthouse Digital
            Service does not violate the privacy rights, publicity rights,
            copyrights, contract rights, intellectual property rights, or any
            other rights of any person; and (iii) the posting of Your User
            Content on the Lighthouse Digital Service does not result in a
            breach of contract between you and a third party. You agree to pay
            all monies owing to any person as a result of posting Your User
            Content on the Lighthouse Digital Service. You also acknowledge and
            agree that Your User Content is non-confidential and
            non-proprietary.
            <br />
            <br />
            The Lighthouse Digital Service contains content from users and other
            Lighthouse Digital licensors. Except as provided within these Terms,
            you may not copy, modify, translate, publish, broadcast, transmit,
            distribute, perform, display, or sell any content appearing on or
            through the Lighthouse Digital Service.
            <br />
            <br />
            <b>IX. Copyright Policy</b>
            <br />
            <br />
            Tell us if you think a user has violated your copyright using the
            Lighthouse Digital Service, or if you think someone incorrectly
            reported that you violated his or her copyright.
            <br />
            <br />
            The Digital Millennium Copyright Act of 1998 (the <b> “DMCA”</b> )
            provides recourse for copyright owners who believe that material
            appearing on the Internet infringes their rights under U.S.
            copyright law. If you believe in good faith that materials posted on
            the Lighthouse Digital Service infringe your copyright, you (or your
            agent) may send Lighthouse Digital a “Notification of Claimed
            Infringement” requesting that the material be removed, or access to
            it blocked. The notice must include the following information:
            <br />
            <br />
            <ol>
              <li>
                A physical or electronic signature of a person authorized to act
                on behalf of the owner of the works that have been allegedly
                infringed;
              </li>
              <li>
                Identification of the copyrighted work alleged to have been
                infringed (or if multiple copyrighted works located on the
                Lighthouse Digital Service are covered by a single notification,
                a representative list of such works);
              </li>
              <li>
                Identification of the specific material alleged to be infringing
                or the subject of infringing activity, and information
                reasonably sufficient to allow Lighthouse Digital to locate the
                material on the Lighthouse Digital Service;
              </li>
              <li>
                Your name, address, telephone number, and email address (if
                available);
              </li>
              <li>
                A statement that you have a good faith belief that use of the
                material in the manner complained of is not authorized by the
                copyright owner, its agent, or the law; and
              </li>
              <li>
                A statement that the information in the notification is
                accurate, and under penalty of perjury, that the complaining
                party is authorized to act on behalf of the owner of an
                exclusive right that is allegedly infringed.
              </li>
            </ol>
            <br />
            If you believe in good faith that a notice of copyright infringement
            has been wrongly filed against you, the DMCA permits you to send
            Lighthouse Digital a counter-notice.
            <br />
            <br />
            {/* hyperlink */}
            Notices and counter-notices must meet the then-current statutory
            requirements imposed by the DMCA; see http://www.loc.gov/copyright/
            for details. Notices and counter-notices with respect to the
            Lighthouse Digital Service should be sent to
            (admin@itsLighthouse.com). Consult your legal advisor and see 17
            U.S.C. § 512 before filing a notice or counter-notice as there are
            penalties for false claims under the DMCA.
            <br />
            <br />
            <b>X. Suggestions and Submissions</b>
            <br />
            <br />
            We appreciate your comments, but if you send us creative ideas, we
            can use them without compensating you.
            <br />
            <br />
            We appreciate hearing from our users and welcome your comments
            regarding the Lighthouse Digital Service. Please be advised,
            however, that if you send us creative ideas, suggestions,
            inventions, or materials ( “creative ideas” ), we shall:
            <ol>
              <li>
                Own, exclusively, all now known or later discovered rights to
                the creative ideas;{" "}
              </li>
              <li>
                {" "}
                Not be subject to any obligation of confidentiality and shall
                not be liable for any use or disclosure of any creative ideas;
                and
              </li>
              <li>
                {" "}
                Be entitled to unrestricted use of the creative ideas for any
                purpose whatsoever, commercial or otherwise, without
                compensation to you or any other person.
              </li>
            </ol>
            <br />
            <b>XI. User Content Disclaimers, Limitations, and Prohibitions</b>
            <br />
            <br />
            You are responsible for your actions when using and relying on the
            Lighthouse Digital Service or content available on the Lighthouse
            Digital Service.
            <br />
            <br />
            We do not represent or guarantee the truthfulness, accuracy, or
            reliability of content, posted by users of the Lighthouse Digital
            Service. You accept that any reliance on material posted by other
            users or third-party service providers will be at your own risk. By
            using the Lighthouse Digital Service you accept the risk that you
            might be exposed to content that is objectionable or otherwise
            inappropriate.
            <br />
            <br />
            You expressly acknowledge and agree that you are solely responsible
            for Your User Content on the Lighthouse Digital Service. Lighthouse
            Digital does not endorse, nor is it responsible for, Your User
            Content on the Lighthouse Digital Service. You assume all risks
            associated with Your User Content, including anyone’s reliance on
            its quality, accuracy, or reliability, and you agree that you are
            solely responsible for any consequences that may arise from the
            posting of Your User Content through the Lighthouse Digital Service.
            You may expose yourself to liability if, for example, Your User
            Content contains material that is false, intentionally misleading,
            or defamatory; violates third-party rights; or contains material
            that is unlawful or advocates the violation of any law or
            regulation.
            <br />
            <br />
            Do not misuse the Lighthouse Digital Service or attempt to break it,
            steal our content or use the Lighthouse Digital Service to post
            unlawful or harmful content.
            <br />
            <br />
            You agree to use the Lighthouse Digital Service only for its
            intended purpose. You must use the Lighthouse Digital Service in
            compliance with all privacy, data protection, intellectual property,
            and other applicable laws. The following uses of the Lighthouse
            Digital Service are prohibited. You may not:
            <br />
            <br />
            <ol>
              <li>
                Attempt to interfere with, harm, reverse engineer, steal from,
                or gain unauthorized access to the Lighthouse Digital Service,
                user accounts, or the technology and equipment supporting the
                Lighthouse Digital Service;
              </li>
              <li>
                {" "}
                Frame or link to the Lighthouse Digital Service without
                permission;
              </li>
              <li>
                Use data mining, robots, or other data gathering devices on or
                through the Lighthouse Digital Service;
              </li>
              <li>
                Post incomplete, false, or misleading information, impersonate
                another person, or misrepresent your affiliation with a person
                or entity;
              </li>
              <li>
                {" "}
                Disclose personal information about another person or post any
                content that is unlawful, pornographic, obscene, defamatory,
                libelous, threatening, discriminatory, harassing, bullying,
                vulgar, indecent, profane, hateful, racially, culturally or
                ethnically offensive, or that encourages criminal conduct or
                that gives rise, or potentially gives rise to civil or criminal
                liability or that violates any applicable law;{" "}
              </li>
              <li>
                Sell, transfer, or assign any of your rights to use the
                Lighthouse Digital Service to a third party without our express
                written consent;
              </li>
              <li>
                {" "}
                Post advertising or marketing links or content, except as
                specifically allowed by these Terms;
              </li>
              <li>
                {" "}
                Use the Lighthouse Digital Service after your account has been
                terminated, without our consent;
              </li>
              <li>
                {" "}
                Use the Lighthouse Digital Service in an illegal way or to
                commit an illegal act in relation to the Lighthouse Digital
                Service or that otherwise results in fines, penalties, and other
                liability to Lighthouse Digital or others; or
              </li>
              <li>
                {" "}
                Access the Lighthouse Digital Service from a jurisdiction where
                it is illegal or unauthorized.
              </li>
            </ol>
          </p>
          <b>XII. Consequences of Violating These Terms</b>
          <br />
          <br />
          If you do not act responsibly and in accordance with these Terms, we
          may prohibit your use of the Lighthouse Digital Service.
          <br />
          <br />
          We reserve the right to suspend or terminate your account and prevent
          access to the Lighthouse Digital Service for any reason, without
          notice to you, at our discretion. We reserve the right to refuse to
          provide the Lighthouse Digital Service to you in the future.
          <br />
          <br />
          Lighthouse Digital may review and remove any of Your User Content at
          any time for any reason, including for any activity which, in its sole
          judgment: violates these Terms; violates applicable laws, rules, or
          regulations; is abusive, disruptive, offensive or illegal; or violates
          the rights of, or harms or threatens the safety of, users of the
          Lighthouse Digital Service.
          <br />
          <br />
          You are responsible for any claims, fees, fines, penalties, and other
          liability incurred by us or others caused by or arising out of your
          breach of these Terms and your use of the Lighthouse Digital Service.
          <br />
          <br />
          <b>XIII. Lighthouse Digital's Liability</b>
          <br />
          <br />
          We are not liable for the actions of our users when they use the
          Lighthouse Digital Service. We may also change the Lighthouse Digital
          Service at any time and are not liable for how this may affect you. We
          do not guarantee the quality or accuracy of any content you view using
          the Lighthouse Digital Service or other websites.
          <br />
          <br />
          <b>Changes to the Lighthouse Digital Service. </b> We may change,
          suspend, or discontinue any aspect of the Lighthouse Digital Service
          at any time, in our sole discretion, including hours of operation or
          availability of the Lighthouse Digital Service or any feature, without
          notice or liability.
          <br />
          <br />
          <b>User Disputes.</b>
          We are not responsible for any disputes or disagreements between you
          and any third party you interact with using the Lighthouse Digital
          Service, including POP licensing or relationship authentication. You
          assume all risk associated with dealing with third parties. You agree
          to resolve disputes directly with the other party. You release
          Lighthouse Digital of all claims, demands, and damages in disputes
          among users of the Lighthouse Digital Service. You also agree not to
          involve us in such disputes. Use caution and common sense when using
          the Lighthouse Digital Service.
          <br />
          <br />
          <b>Content Accuracy. </b>We make no representations about accuracy,
          reliability, completeness, or timeliness of any contents of the
          Lighthouse Digital Service. Similarly, we make no representations
          about accuracy, reliability, completeness, or timeliness of any data
          from a third-party service provider or the quality or nature of
          third-party products or services obtained through the Lighthouse
          Digital Service. Use the Lighthouse Digital Service at your own risk.
          Third-Party Websites. The Lighthouse Digital Service may include links
          to third party websites and applications, such as Schoology. You are
          responsible for evaluating whether you want to access or use them. We
          are not responsible for and do not endorse any features, content,
          advertising, products, or other materials on other websites or
          applications. You assume all risk and we disclaim all liability
          arising from your use of them.
          <br />
          <br />
          We make no promises and disclaim all liability of specific results
          from the use of the Lighthouse Digital Service.
          <br />
          <br />
          <b>A. DISCLAIMER OF WARRANTIES </b>
          <br />
          <br />
          <b>Released Parties Defined.</b> “Released Parties” include Lighthouse
          Digital and its affiliates, officers, employees, agents, service
          providers, partners, Instructors, and licensors.
          <br />
          <br />
          You use the Lighthouse Digital Service at your own risk. We make no
          warranties or guarantees.
          <br />
          <br />
          YOU EXPRESSLY UNDERSTAND AND AGREE THAT THE RELEASED PARTIES SHALL NOT
          BE LIABLE TO YOU OR ANYONE ELSE, UNDER ANY THEORY OF LIABILITY
          (WHETHER IN CONTRACT, TORT, STATUTORY OR OTHERWISE), FOR ANY DIRECT,
          INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR EXEMPLARY DAMAGES,
          INCLUDING, BUT NOT LIMITED TO, DAMAGES FOR LOSS OF PROFITS, GOODWILL,
          USE, DATA OR OTHER INTANGIBLE LOSSES (EVEN IF LIGHTHOUSE DIGITAL HAS
          BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES), RESULTING FROM: (i)
          THE USE OR THE INABILITY TO USE THE LIGHTHOUSE DIGITAL SERVICE; (ii)
          THE COST OF PROCUREMENT OF SUBSTITUTE GOODS AND SERVICES RESULTING
          FROM ANY GOODS, DATA, INFORMATION OR SERVICES OBTAINED OR MESSAGES
          RECEIVED OR TRANSACTIONS ENTERED INTO THROUGH, FROM, OR AS A RESULT OF
          THE LIGHTHOUSE DIGITAL SERVICE; (iii) UNAUTHORIZED ACCESS TO OR
          ALTERATION OF YOUR TRANSMISSIONS OR DATA; (iv) STATEMENTS OR CONDUCT
          OF ANY USER OR THIRD PARTY ON THE LIGHTHOUSE DIGITAL SERVICE; (v) YOUR
          RELIANCE ON CONTENT MADE AVAILABLE BY US; OR (vi) ANY OTHER MATTER
          RELATING TO THE LIGHTHOUSE DIGITAL SERVICE. SOME JURISDICTIONS DO NOT
          ALLOW THE EXCLUSION OF CERTAIN WARRANTIES OR THE LIMITATION OR
          EXCLUSION OF LIABILITY FOR INCIDENTAL OR CONSEQUENTIAL DAMAGES.
          ACCORDINGLY, SOME OF THE ABOVE LIMITATIONS IN THIS PARAGRAPH MAY NOT
          APPLY TO YOU.
          <br></br>
          <br></br>
          TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, OUR MAXIMUM
          LIABILITY ARISING OUT OF OR IN CONNECTION WITH THE LIGHTHOUSE DIGITAL
          SERVICE OR YOUR USE OF LIGHTHOUSE DIGITAL CONTENT, REGARDLESS OF THE
          CAUSE OF ACTION (WHETHER IN CONTRACT, TORT, BREACH OF WARRANTY, OR
          OTHERWISE), WILL NOT EXCEED $100.
          <br></br>
          <br></br>
          <b> Indemnification. </b>
          You agree to defend, indemnify, and hold harmless the Released Parties
          from and against any and all claims, liabilities, damages, losses,
          costs, expenses, fees, actions, or demands, including, without
          limitation, reasonable legal and accounting fees, alleging or
          resulting from (i) your use of or reliance on any third-party content,
          (ii) your use of or reliance on any Lighthouse Digital Content, (iii)
          any of Your User Content, (iv) your violation of any person’s
          intellectual property, privacy, publicity or other right, (v) the
          violation of any applicable laws and/or these Terms by you and/or
          anyone using your log-in credentials to access and otherwise use the
          Lighthouse Digital Service (in whole or in part), (vi) the breach of
          any of your warranties, representations, responsibilities or other
          obligations set forth in these Terms, or (vii) the willful misconduct
          of you or anyone accessing the Lighthouse Digital Service using your
          log-in credentials. We shall provide notice to you promptly of any
          such claim, suit, or proceeding. We reserve the right to assume the
          exclusive defense and control of any matter otherwise subject to
          indemnification by you, in which event you will cooperate with us in
          asserting any available defenses. This provision shall remain in full
          force and effect notwithstanding any termination of your use of the
          Lighthouse Digital Service.
          <br></br>
          <br></br>
          These Terms constitute the entire agreement between you and Lighthouse
          Digital concerning your use of the Lighthouse Digital Service. Our
          failure to exercise or enforce any right or provision of these Terms
          shall not constitute a waiver of such right or provision. If any
          provision of these Terms is found by a court of competent jurisdiction
          to be invalid, the parties nevertheless agree that the court should
          endeavor to give effect to the parties’ intentions as reflected in the
          provision, and the other provisions of these Terms remain in full
          force and effect. The section titles and annotations in these Terms
          are for convenience only and have no legal or contractual effect.
          <br></br>
          <br></br>
          <b>XV. Arbitration, Class Waiver, and Waiver of Jury Trial</b>
          <br></br>
          <br></br>
          We are located in Atlanta GA, and all disputes must be resolved there.
          We will use arbitration to resolve any problems, and you cannot join a
          class action lawsuit or obtain a jury trial for any disputes you have
          with us related to your use of the Lighthouse Digital Service.
          <br></br>
          <br></br>
          These Terms and the relationship between you and Lighthouse Digital
          shall be governed by the laws of the state of Georgia without regard
          to its conflict of law provisions, regardless of where you live. You
          and Lighthouse Digital agree to submit any disputes relating to your
          use of the Lighthouse Digital Service for final and binding
          arbitration under the rules of the American Arbitration Association.
          Any such arbitration, to the extent necessary, shall be conducted in
          Atlanta, Georgia. You covenant not to sue Lighthouse Digital in any
          other forum.
          <br></br>
          <br></br>
          You also acknowledge and understand that, with respect to any dispute
          with the Released Parties arising out of or relating to your use of
          the Lighthouse Digital Service or these Terms:
          <li> YOU ARE GIVING UP YOUR RIGHT TO HAVE A TRIAL BY JURY;</li>
          <li>
            {" "}
            YOU ARE GIVING UP YOUR RIGHT TO SERVE AS A REPRESENTATIVE, AS A
            PRIVATE ATTORNEY GENERAL, OR IN ANY OTHER REPRESENTATIVE
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;CAPACITY, OR TO PARTICIPATE AS A
            MEMBER OF A CLASS OF CLAIMANTS, IN ANY LAWSUIT INVOLVING ANY SUCH
            DISPUTE; AND
          </li>
          <li>
            YOU MUST FILE ANY CLAIM WITHIN ONE (1) YEAR AFTER SUCH CLAIM AROSE
            OR IT IS FOREVER BARRED.
          </li>
          <br></br>
          Contact Information
          <br></br>
          <br></br>
          Lighthouse Digital LLC
          <br></br>
          3550 Lenox Road NE Suite 2100
          <br></br>
          Atlanta ,GA 30326
        </Container>
      </div>
    );
  }
}

export default PrivacyPolicy;
